exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-content{\n    max-width: 100% !important;\n}\n", ""]);

// exports
